import { Axios } from 'axios'

import { type ErrorResponse, okResponse, type RawResponse, toGsResponse } from '../../goodstack'
import { VolunteeringTimeLogType } from '../../opportunity/dto'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { LogVolunteeringActivityParams } from './logVolunteeringActivity.types'

export const TIME_LOG_OVERLAP_CODE = 'volunteering/time_log_overlap'

export type LogVolunteeringActivityFailure = { index: number } & ErrorResponse

export type LogVolunteeringActivityResult = {
  succeededIndices: number[]
  failures: LogVolunteeringActivityFailure[]
}

export const logVolunteeringActivity: MutationFn<
  [LogVolunteeringActivityParams],
  LogVolunteeringActivityResult
> = async (client: Axios, [params]) => {
  const { timeLogs, duringWorkingHours, confirmed, ...logData } = params

  const responses = await Promise.all(
    timeLogs.map(async timeLog =>
      client.post<RawResponse<unknown>>(
        'v1/account/volunteering-time-logs',
        {
          ...timeLog,
          ...logData,
          ...(duringWorkingHours !== undefined ? { duringWorkingHours } : {}),
          ...(confirmed !== undefined ? { confirmed } : {}),
          ...(logData.platform === VolunteeringTimeLogType.OffPlatform &&
            logData.activities && {
              activities: JSON.stringify(logData.activities)
            }),
          ...(logData.platform === VolunteeringTimeLogType.OffPlatform &&
            logData.skills && {
              skills: JSON.stringify(logData.skills)
            })
        },
        {
          withCredentials: true,
          validateStatus: (_: number) => true
        }
      )
    )
  )

  const succeededIndices: number[] = []
  const failures: LogVolunteeringActivityFailure[] = []

  responses.forEach((response, index) => {
    const gsResponse = toGsResponse(response.status, response.data)

    if (okResponse(gsResponse)) {
      succeededIndices.push(index)
    } else {
      failures.push({ index, ...gsResponse })
    }
  })

  return { succeededIndices, failures }
}
